import React from "react";

const NotificationBell = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="8" fill="#F7F7FD" />
      <g clipPath="url(#clip0_1651_14745)">
        <path
          d="M14.3905 18.125C14.3894 17.3837 14.5351 16.6496 14.8191 15.9649C15.1031 15.2802 15.5198 14.6585 16.0452 14.1357C16.5706 13.6128 17.1943 13.1991 17.8804 12.9184C18.5664 12.6377 19.3012 12.4955 20.0424 12.5001C23.1354 12.5231 25.6094 15.094 25.6094 18.1956V18.75C25.6094 21.548 26.1948 23.1717 26.7104 24.0592C26.7659 24.154 26.7955 24.2618 26.7961 24.3717C26.7966 24.4816 26.7682 24.5897 26.7137 24.6851C26.6592 24.7805 26.5805 24.8599 26.4855 24.9151C26.3905 24.9704 26.2826 24.9997 26.1727 25H13.8264C13.7165 24.9997 13.6087 24.9704 13.5137 24.9151C13.4187 24.8598 13.34 24.7805 13.2854 24.685C13.2309 24.5896 13.2025 24.4815 13.2031 24.3716C13.2037 24.2617 13.2333 24.1539 13.2889 24.059C13.8048 23.1716 14.3905 21.5479 14.3905 18.75L14.3905 18.125Z"
          stroke="#000929"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 25V25.625C17.5 26.288 17.7634 26.9239 18.2322 27.3928C18.7011 27.8616 19.337 28.125 20 28.125C20.663 28.125 21.2989 27.8616 21.7678 27.3928C22.2366 26.9239 22.5 26.288 22.5 25.625V25"
          stroke="#000929"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <mask
          id="path-4-outside-1_1651_14745"
          maskUnits="userSpaceOnUse"
          x="20"
          y="11.668"
          width="9"
          height="9"
          fill="black"
        >
          <rect fill="white" x="20" y="11.668" width="9" height="9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.3333 15.8346C26.3333 17.0313 25.3633 18.0013 24.1667 18.0013C22.97 18.0013 22 17.0313 22 15.8346C22 14.638 22.97 13.668 24.1667 13.668C25.3633 13.668 26.3333 14.638 26.3333 15.8346Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.3333 15.8346C26.3333 17.0313 25.3633 18.0013 24.1667 18.0013C22.97 18.0013 22 17.0313 22 15.8346C22 14.638 22.97 13.668 24.1667 13.668C25.3633 13.668 26.3333 14.638 26.3333 15.8346Z"
          fill="#7065F0"
        />
        <path
          d="M24.1667 20.0013C26.4679 20.0013 28.3333 18.1358 28.3333 15.8346H24.3333C24.3333 15.9267 24.2587 16.0013 24.1667 16.0013V20.0013ZM20 15.8346C20 18.1358 21.8655 20.0013 24.1667 20.0013V16.0013C24.0746 16.0013 24 15.9267 24 15.8346H20ZM24.1667 11.668C21.8655 11.668 20 13.5334 20 15.8346H24C24 15.7426 24.0746 15.668 24.1667 15.668V11.668ZM28.3333 15.8346C28.3333 13.5334 26.4679 11.668 24.1667 11.668V15.668C24.2587 15.668 24.3333 15.7426 24.3333 15.8346H28.3333Z"
          fill="#F7F7FD"
          mask="url(#path-4-outside-1_1651_14745)"
        />
      </g>
      <defs>
        <clipPath id="clip0_1651_14745">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NotificationBell;
